// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3J2_M","right":"Footer_right__1ivqZ","buttons":"Footer_buttons__1-xSN"};